import {useEffect, useState, useCallback} from 'react'
import {useScript} from '../../hooks'


// Documentation: https://developers.google.com/identity/gsi/web/guides/overview
/**
 * GoogleAuthButton
 *
 * Renders the Google Sign‑In button using Google’s Identity Services.
 * Props:
 *  - context: 'signin' | 'signup' (default 'signin')
 *  - callback: function(token: string) — called on successful sign‑in
 *  - showPrompt: boolean — whether to automatically show the One‑Tap prompt
 *  - text: 'signin_with' | 'signup_with' (default 'signin_with')
 */
const GoogleAuthButton = ({
  text = 'signin_with',
  shape = 'pill',
  context = 'signin',
  callback,
  showPrompt = true
}) => {

  const [isLoaded] = useScript('https://accounts.google.com/gsi/client')
  const [initialized, setInitialized] = useState(false)

  const handleCredentialResponse = useCallback(
    (response) => {
      if (callback && response.credential) {
        callback(response.credential)
      }
    },
    [callback]
  )

  useEffect(() => {
    if (!isLoaded || initialized) return

    const googleId = window.google?.accounts?.id
    if (!googleId) return

    // Initialize the Google Identity Services SDK
    googleId.initialize({
      client_id: process.env.REACT_APP_GOOGLE_SIGNIN_CLIENT_ID,
      context,
      callback: handleCredentialResponse
    })

  const container = document.getElementById('google-signin-btn')
  const width     = container.getBoundingClientRect().width

    // Render the button into our container
    googleId.renderButton(document.getElementById('google-signin-btn'), {
      text,
      shape,
      theme: 'filled_black',
      logo_alignment: 'left',
      width
    })

    // Optionally show the One‑Tap prompt
    if (showPrompt) {
      googleId.prompt()
    }

    setInitialized(true)
  }, [
    text,
    shape,
    context,
    isLoaded,
    showPrompt,
    initialized,
    handleCredentialResponse
  ])


  return <div id='google-signin-btn' />
}


export default GoogleAuthButton




